import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthorizeService } from "../services";
import { map } from "rxjs/operators";

export const OnlyPublicGuard: CanActivateFn = () => {
    const authCheck = inject(AuthorizeService).isAuthenticated();
    const redirect = inject(Router).createUrlTree(["switch"]);

    return authCheck.pipe(map((check) => !check || redirect));
}
